// vim: set ts=2 sts=2 sw=2 et:

import React from "react";

import crest from "../../dmxHelper/assets/wrpfarg-logo.webp";
import type { WrpfSponsor } from "../../handoff/types";
import sponsorStrip from "./assets/sponsors-iberoamericano-2026.png";

import styles from "./BroadcastHeader.module.scss";

interface Props {
  tournamentName: string;
  sessionLabel: string;
  sponsors: ReadonlyArray<WrpfSponsor>;
}

// Barra superior compartida por el overlay y la ficha: torneo a la izquierda, sponsors locales fijos a la derecha.
const BroadcastHeader = ({ tournamentName, sessionLabel }: Props) => (
  <header className={styles.topBar}>
    <img className={styles.crest} src={crest} alt="WRPF Argentina" />
    <div className={styles.tournament}>
      <strong>{tournamentName}</strong>
      <span>{sessionLabel}</span>
    </div>
    <span className={styles.headerSlash} aria-hidden="true" />
    <div className={styles.sponsors} aria-label="Sponsors del torneo">
      <img src={sponsorStrip} alt="Sponsors del Campeonato Iberoamericano WRPF 2026" />
    </div>
    <span className={styles.endSlash} aria-hidden="true" />
  </header>
);

export default BroadcastHeader;
